/**
 * 自動回應管理 API Service
 */

import apiClient from '../axios.js';

export const autoReplyService = {
  // ==================== 規則管理 ====================

  /**
   * 查詢規則列表
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 規則列表
   */
  async listRules(params) {
    const response = await apiClient.get('/admin/auto-reply/rules', { params });
    return response;
  },

  /**
   * 查詢規則詳情
   * @param {string} id - 規則 ID
   * @returns {Promise<Object>} 規則詳情
   */
  async getRule(id) {
    const response = await apiClient.get(`/admin/auto-reply/rules/${id}`);
    return response;
  },

  /**
   * 建立規則
   * @param {Object} data - 規則資料
   * @returns {Promise<Object>} 創建的規則
   */
  async createRule(data) {
    const response = await apiClient.post('/admin/auto-reply/rules', data);
    return response;
  },

  /**
   * 更新規則
   * @param {string} id - 規則 ID
   * @param {Object} data - 規則資料
   * @returns {Promise<Object>} 更新後的規則
   */
  async updateRule(id, data) {
    const response = await apiClient.put(`/admin/auto-reply/rules/${id}`, data);
    return response;
  },

  /**
   * 刪除規則
   * @param {string} id - 規則 ID
   * @returns {Promise<Object>} 刪除結果
   */
  async deleteRule(id) {
    const response = await apiClient.delete(`/admin/auto-reply/rules/${id}`);
    return response;
  },

  // ==================== 統計與優化 ====================

  /**
   * 查詢統計資料
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 統計資料
   */
  async getStatistics(params) {
    const response = await apiClient.get('/admin/auto-reply/statistics', { params });
    return response;
  },

  /**
   * 查詢未匹配訊息列表
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 未匹配訊息列表
   */
  async listUnmatchedMessages(params) {
    const response = await apiClient.get('/admin/auto-reply/unmatched', { params });
    return response;
  },

  /**
   * 標記未匹配訊息為已處理
   * @param {string} id - 訊息 ID
   * @returns {Promise<Object>} 處理結果
   */
  async processUnmatchedMessage(id) {
    const response = await apiClient.put(`/admin/auto-reply/unmatched/${id}/process`);
    return response;
  },

  // ==================== 時段控制 ====================

  /**
   * 查詢營業時間設定
   * @returns {Promise<Object>} 營業時間設定
   */
  async getBusinessHours() {
    const response = await apiClient.get('/admin/auto-reply/business-hours');
    return response;
  },

  /**
   * 更新營業時間設定
   * @param {Object} data - 設定資料
   * @returns {Promise<Object>} 更新後的設定
   */
  async updateBusinessHours(data) {
    const response = await apiClient.put('/admin/auto-reply/business-hours', data);
    return response;
  }
};
